import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UrlUtilityService {
    constructor() { }

    getUrlLink(urlObjectString: string): string {
        const urlLinkObject = JSON.parse(urlObjectString);
        return this.hasProtocol(urlLinkObject.urlLink);
    }

    getUrlLabel(urlObjectString: string): string {
        const urlLinkObject = JSON.parse(urlObjectString);
        if (urlLinkObject.label) {
            return urlLinkObject.label;
        }

        return this.hasProtocol(urlLinkObject.urlLink);
    }

    shortenedLink(link: string): string {
        let shortenedLink = link;

        if (link?.length > 16) {
            shortenedLink = link.substring(0, 16).concat('...');
        }

        return shortenedLink;
    }

    hasProtocol(url: string): string {
        if (!url?.includes("http")) {
            return `http://${url}`;
        }
        return url;
    }
}
